"use client";

import { useState } from "react";

interface CollapsibleTextProps {
  text: string;
  readMoreSettings?: any;
  isRtl: boolean;
}

export default function CollapsibleText({ text, readMoreSettings, isRtl }: CollapsibleTextProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!readMoreSettings?.enableReadMore) {
    return (
      <div className="text-sm md:text-base text-gray-600 max-w-4xl mx-auto leading-relaxed mt-2" style={{ whiteSpace: "pre-line" }}>
        {text}
      </div>
    );
  }

  const {
    enableReadMore,
    mobileLineClamp,
    desktopLineClamp,
    readMoreLabels,
  } = readMoreSettings;

  const readMore = readMoreLabels?.readMore || (isRtl ? "اقرأ المزيد" : "Read More");
  const readLess = readMoreLabels?.readLess || (isRtl ? "اقرأ أقل" : "Read Less");

  const mobileCharLimit = mobileLineClamp ? mobileLineClamp * 55 : undefined;
  const desktopCharLimit = desktopLineClamp ? desktopLineClamp * 80 : undefined;

  const truncateText = (txt: string, limit?: number) => {
    if (!limit || txt.length <= limit) return txt;
    const lastSpace = txt.lastIndexOf(" ", limit);
    return txt.slice(0, lastSpace > 0 ? lastSpace : limit) + "...";
  };

  const mobileDisplayText = !isExpanded ? truncateText(text, mobileCharLimit) : text;
  const desktopDisplayText = !isExpanded ? truncateText(text, desktopCharLimit) : text;

  const isMobileTruncated = mobileCharLimit && text.length > mobileCharLimit;
  const isDesktopTruncated = desktopCharLimit && text.length > desktopCharLimit;

  return (
    <div className="max-w-4xl mx-auto leading-relaxed mt-2">
      {/* Mobile/Tablet Version */}
      <div className="lg:hidden text-sm text-gray-600" style={{ whiteSpace: "pre-line" }}>
        <span>{mobileDisplayText}</span>
        {enableReadMore && mobileLineClamp && isMobileTruncated && (
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="underline font-semibold ml-2 hover:opacity-75 transition-opacity"
          >
            {isExpanded ? readLess : readMore}
          </button>
        )}
      </div>

      {/* Desktop Version */}
      <div className="hidden lg:block text-base text-gray-600" style={{ whiteSpace: "pre-line" }}>
        <span>{desktopDisplayText}</span>
        {enableReadMore && desktopLineClamp && isDesktopTruncated && (
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="underline font-semibold ml-2 hover:opacity-75 transition-opacity"
          >
            {isExpanded ? readLess : readMore}
          </button>
        )}
      </div>
    </div>
  );
}
